// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the HandlerModels.tst template. 
// !!Do not modify this file or change may be lost!!
// SaveRoleDetailsHandler
/* eslint-disable */
// @ts-ignore
import * as moment from 'moment';
import RoleDTO from '../models/RoleDTO';
import ResultDTO from '../models/ResultDTO';

interface Request {
    roleId: string | null | null;
    role: RoleDTO | null;
}

const Request = {
    create: (initValues?: Partial<Request> | Record<string, unknown> | null) => {
        return Object.assign(
        {
            roleId: null,
            role: null,
        },
        initValues);
    },
    roleId: 'roleId',
    role: 'role',
}

interface Result extends ResultDTO {
    roleId: string | null;
}

const Result = {
    create: (initValues?: Partial<Result> | Record<string, unknown> | null) => {
        return Object.assign(ResultDTO.create(),
        {
            roleId: '00000000-0000-0000-0000-000000000000',
        },
        initValues);
    },
    roleId: 'roleId',
}

export { Request, Result };